import { DirectionalHint } from "@fluentui/react";
import React, { FunctionComponent } from "react";
import { CoachmarkInfo } from "../CoachmarkInfo";
import { PFCoachmark } from "../PFCoachmark";
import { useTranslation } from "../../Locales/i18n/localizationService";
import { CoachmarkLocaleItem } from "../../Locales/Coachmarks/Locale_CoachmarkItem";

export const LMCapacityCoachmarks: FunctionComponent<any> = React.memo(props => {
	const { t } = useTranslation();
	const projectText = new CoachmarkLocaleItem(t("Coachmarks.LMCapacity.Project.Headline"), t("Coachmarks.LMCapacity.Project.Text"));
	const resourceText = new CoachmarkLocaleItem(t("Coachmarks.LMCapacity.Resource.Headline"), t("Coachmarks.LMCapacity.Resource.Text"));
	const settingsText = new CoachmarkLocaleItem(t("Coachmarks.LMCapacity.Settings.Headline"), t("Coachmarks.LMCapacity.Settings.Text"));
	const viewText = new CoachmarkLocaleItem(t("Coachmarks.LMCapacity.View.Headline"), t("Coachmarks.LMCapacity.View.Text"));
	const dropText = new CoachmarkLocaleItem(t("Coachmarks.LMCapacity.Drop.Headline"), t("Coachmarks.LMCapacity.Drop.Text"));
	const _project = new CoachmarkInfo("plannerview-project", "#project-overlay-button", projectText, DirectionalHint.rightCenter);
	const _resource = new CoachmarkInfo("plannerview-resource", "#resource-overlay-button", resourceText, DirectionalHint.leftCenter);
	const _settings = new CoachmarkInfo("plannerview-settings", ".lmcapacity-settings-buttons-top", settingsText, DirectionalHint.rightCenter);
	const _view = new CoachmarkInfo("plannerview-views", ".lmcapacity-settings-dropdowns", viewText, DirectionalHint.bottomCenter);
	const _drop = new CoachmarkInfo("plannerview-dropzone", ".tp-lmcapacity-pickercontainer", dropText, DirectionalHint.bottomRightEdge);
	
	return	<>
				<PFCoachmark CoachmarkInfo={_project} />
				<PFCoachmark CoachmarkInfo={_resource} />
				<PFCoachmark CoachmarkInfo={_settings} />
				<PFCoachmark CoachmarkInfo={_view} />
				<PFCoachmark CoachmarkInfo={_drop} />
			</>
})